import { render, staticRenderFns } from "./CyCrkManageAdd.vue?vue&type=template&id=23655518&scoped=true"
import script from "./CyCrkManageAdd.vue?vue&type=script&lang=js"
export * from "./CyCrkManageAdd.vue?vue&type=script&lang=js"
import style0 from "./CyCrkManageAdd.vue?vue&type=style&index=0&id=23655518&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23655518",
  null
  
)

export default component.exports